// Edika — Recharge subscription widget translation (Langify replacement).
//
// The <recharge-subscription-widget> renders inside a shadow root and Recharge's
// admin is single-locale (FR), so Shopify's native translations can't reach its
// text. This translates the rendered widget on non-FR (English) pages. Only the
// ~2 product templates using the Recharge app-block widget have this element;
// elsewhere it's a no-op. Adapted from cafe-saint-henri custom.js.
(function () {
  var lang = (document.documentElement.lang || "fr").toLowerCase();
  if (lang.indexOf("fr") === 0) return; // run on English only

  var translations = {
    "Options d'achat": "Purchase options",
    "Achat unique": "One-time purchase",
    "S'abonner et économiser": "Subscribe and save",
    "Abonnez-vous et économisez": "Subscribe and save",
    "S'abonner et économiser 20%": "Subscribe and save 20%",
    "Abonnez-vous et économisez 20%": "Subscribe and save 20%",
    "Détails de l'abonnement": "Subscription details",
    "Détails d'abonnement": "Subscription details",
    "Comment fonctionne l'abonnement": "How subscriptions work",
    "Le plus populaire": "Most popular",
    "Plus populaire": "Most popular",
    "Fréquence de livraison": "Delivery frequency",
    "Fréquence d'abonnement": "Subscription frequency",
    "Fréquence": "Frequency",
    "Ne manquez jamais de café": "Never run out of coffee",
    "Ne manquez plus jamais de café": "Never run out of coffee",
    "Modifiez votre abonnement à tout moment": "Change your subscription at any time",
    "Mise en pause et annulation à votre guise": "Pause and cancel as you wish",
    "Un minimum de 3 commandes est requis.": "A minimum of 3 orders is required.",
    "Livraison chaque semaine": "Every week",
    "Livraison chaque jour": "Every day",
    "Livraison chaque mois": "Every month",
    "Abonnement Mensuel": "Monthly",
    "Abonnement Hebdomadaire": "Weekly",
    "Ajouter au panier": "Add to cart"
  };

  var regexTranslations = [
    { p: /Économisez\s+(\d+)\s*%/g, r: "Save $1%" },
    { p: /Livraison chaque (\d+) semaines?/gi, r: "Delivery every $1 weeks" },
    { p: /Livraison toutes les (\d+) semaines?/gi, r: "Delivery every $1 weeks" },
    { p: /Livraison chaque (\d+) jours?/gi, r: "Delivery every $1 days" },
    { p: /Livraison chaque (\d+) mois/gi, r: "Delivery every $1 months" },
    { p: /Abonnement aux (\d+) semaines/gi, r: "Every $1 weeks" },
    { p: /Abonnement aux (\d+) mois/gi, r: "Every $1 months" }
  ];

  var observed = new WeakSet();

  function collectShadowRoots(root, roots) {
    var els = root.querySelectorAll("*");
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) { roots.push(els[i].shadowRoot); collectShadowRoots(els[i].shadowRoot, roots); }
    }
  }

  function translateRoot(root) {
    var changed = false;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), node;
    while ((node = walker.nextNode())) {
      var original = node.textContent, updated = original;
      for (var i = 0; i < regexTranslations.length; i++) updated = updated.replace(regexTranslations[i].p, regexTranslations[i].r);
      var trimmed = updated.trim();
      if (translations.hasOwnProperty(trimmed)) updated = updated.replace(trimmed, translations[trimmed]);
      if (updated !== original) { node.textContent = updated; changed = true; }
    }
    return changed;
  }

  function translateWidget() {
    var host = document.querySelector("recharge-subscription-widget");
    if (!host || !host.shadowRoot) return false;
    var roots = [host.shadowRoot];
    collectShadowRoots(host.shadowRoot, roots);
    var done = false;
    roots.forEach(function (root) {
      if (translateRoot(root)) done = true;
      if (!observed.has(root)) {
        observed.add(root);
        new MutationObserver(function () { translateWidget(); }).observe(root, { childList: true, subtree: true, characterData: true });
      }
    });
    return done;
  }

  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    if (translateWidget() || attempts > 100) clearInterval(interval); // ~10s of polling for mount
  }, 100);
})();
